class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.openRebuySmartCart(cartLink, event);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.openRebuySmartCart(cartLink, event);
      }
    });
  }

  /**
   * Open Rebuy Smart Cart only (no theme drawer). Waits for rebuy:smartcart.ready if Rebuy is not ready yet.
   * @param {HTMLElement | null} triggeredBy
   * @param {Event} [activatorEvent]
   */
  openRebuySmartCart(triggeredBy, activatorEvent) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const openNative = () => this.open(triggeredBy);

    const tryShow = () => {
      try {
        if (window.Rebuy?.SmartCart?.show) {
          Rebuy.SmartCart.show(activatorEvent);
          return true;
        }
      } catch (e) {
        console.error(e);
      }
      return false;
    };

    if (tryShow()) return;

    let settled = false;
    const onReady = () => {
      if (settled) return;
      settled = true;
      window.clearTimeout(fallbackTimer);
      if (!tryShow()) openNative();
    };

    const fallbackTimer = window.setTimeout(() => {
      if (settled) return;
      settled = true;
      document.removeEventListener('rebuy:smartcart.ready', onReady);
      if (!tryShow()) openNative();
    }, 4000);

    document.addEventListener('rebuy:smartcart.ready', onReady, { once: true });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    let chatBubble = document.querySelector('.richpanel-micro');

    if (chatBubble) {
      chatBubble.classList.add('hidden');
    }

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    let chatBubble = document.querySelector('.richpanel-micro');

    if (chatBubble) {
      chatBubble.classList.remove('hidden');
    }
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.openRebuySmartCart(null);
    });

    setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { source: 'cart-drawer-render' },
        })
      );
    }, 1000);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    // Call the parent method which handles the cart update
    super.updateQuantity(line, quantity, name);

    setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { source: 'cart-drawer-quantity-update' },
        })
      );
    }, 1000);
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
